import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// Helpers
import AuthHelper from './helpers/auth';

// Layouts
import BasicLayout from './layouts/BasicLayout';
import NavigationLayout from './layouts/NavigationLayout';

import LoginPage from './containers/LoginPage';
import LoginVerificationPage from './containers/LoginVerificationPage';
import SignUpPage from './containers/SignUpPage';
import SignUpVerificationPage from './containers/SignUpVerificationPage';
import LogoutPage from './containers/LogoutPage';

import ApplicationPage from './containers/ApplicationPage';

const routes = [
	// Authentication Routes
	{ path: '/login', exact: true, isPrivate: false, Layout: BasicLayout, Component: LoginPage },
	{ path: '/login/verify', exact: true, isPrivate: false, Layout: BasicLayout, Component: LoginVerificationPage },
	{ path: '/create', exact: true, isPrivate: false, Layout: BasicLayout, Component: SignUpPage },
	{ path: '/create/verify', exact: true, isPrivate: false, Layout: BasicLayout, Component: SignUpVerificationPage },
	{ path: '/logout', exact: true, isPrivate: false, Layout: BasicLayout, Component: LogoutPage },

	{ path: '/', exact: true, isPrivate: true, Layout: NavigationLayout, Component: ApplicationPage },
	{ path: '/application', exact: true, isPrivate: true, Layout: NavigationLayout, Component: ApplicationPage }
];

const getRedirectedPath = (location) => {
	if (location.pathname.split('?')[0] === '/login' && location.pathname.split('?').length > 1) {
		return location.pathname + location.search + location.hash;
	}

	// Skip the redirection from these routes
	if (['/login', '/callback/cas', '/logout'].indexOf(location.pathname.split('?')[0]) !== -1) {
		return '/login';
	}
	
	return `/login?path=${location.pathname + location.search + location.hash}`;
};

const PrivateRoute = ({ layout: Layout, component: Component, location, ...rest }) => (
	<Route
		{...rest}
		render={props => {
			if (AuthHelper.isAuthenticated()) {
				return (
					<Layout>
						<Component {...props} />
					</Layout>
				);
			} else {
				return (
					<Redirect
						to={{
							pathname: getRedirectedPath(location),
							state: { from: location }
						}}
					/>
				);
			}
		}}
	/>
);

const Routes = ({ location }) => {
	return (
		<Switch location={location}>
			{routes.map(({ path, exact, isPrivate, Layout, Component }) => {
				if (isPrivate) {
					return <PrivateRoute
						key={0}
						path={path}
						exact={exact}
						layout={Layout}
						component={Component}
						location={location}
					       />;
				} else {
					return (
						<Route
							key={0}
							path={path}
							exact={exact}
							render={props => (
								<Layout location={location}>
									<Component {...props} />
								</Layout>
							)}
						/>
					);
				}
			})}
			<Route render={props => (AuthHelper.isAuthenticated() ? <Redirect to={'/application'} /> : <Redirect to={getRedirectedPath(props.location)} />)} />
		</Switch>
	);
};

export default Routes;